import { Box, Tab, Tabs, styled } from '@mui/material';
import { FC, ReactNode, useState } from 'react';
import {
  CustomTabPanel,
  UserRooms,
  tabProps,
  useTabChange,
} from '../components';
import { InviteUsers } from './invite-players';
import { InviteBots, PaginationSlotContext } from './components';
import '@/theme/ios-screen.css';

export const InviteBoxStyled = styled(Box)(() => ({
  display: 'grid',
  gridTemplateColumns: 'auto 1fr auto',
  gap: 1,
  minHeight: 50,
  maxWidth: 500,
  alignItems: 'center',
}));

const TABS_NAMES = ['Users', 'Bots', 'Rooms'];

export const InvitePlayersPage: FC = () => {
  const { handleTabChange, value } = useTabChange(TABS_NAMES);
  const [paginationContent, setPaginationContent] = useState<ReactNode>(null);

  return (
    <PaginationSlotContext.Provider value={setPaginationContent}>
      {/* Bounded screen: 100dvh minus the measured top bar (incl. notch) and
          the native keyboard; the list scrolls inside its own region and the
          pagination row below is always visible. */}
      <div className="bh-invite-screen">
        {/* Tab strip — fixed height, never shrinks */}
        <Tabs
          onChange={handleTabChange}
          aria-label="basic tabs"
          value={value}
          variant="fullWidth"
        >
          <Tab label="Users" {...tabProps(0)} />
          <Tab label="Bots" {...tabProps(1)} />
          <Tab label="Rooms" {...tabProps(2)} />
        </Tabs>

        {/* Main content area — everything between the tabs and pagination.
            position:relative + absolute tab panels guarantees the height
            chain is definite regardless of how the flex algorithm resolved
            the flex size (height:100% on children of flex items is
            unreliable across browsers). */}
        <div style={{ flex: '1 1 auto', minHeight: 0, overflow: 'hidden', position: 'relative' }}>
          <CustomTabPanel value={value} index={0} style={{ position: 'absolute', inset: 0 }}>
            <InviteUsers />
          </CustomTabPanel>
          <CustomTabPanel value={value} index={1} style={{ position: 'absolute', inset: 0 }}>
            <InviteBots />
          </CustomTabPanel>
          <CustomTabPanel value={value} index={2} style={{ position: 'absolute', inset: 0 }}>
            <UserRooms />
          </CustomTabPanel>
        </div>

        {/* Shared pagination row — sized to its content (44px controls) and
            padded for the home indicator. Users and Rooms tabs push their
            <BhabiPagination> here via PaginationSlotContext; Bots leaves it
            empty. */}
        <div className="bh-invite-screen__foot">{paginationContent}</div>
      </div>
    </PaginationSlotContext.Provider>
  );
};
